import { render, staticRenderFns } from "./person-position-grid-new.vue?vue&type=template&id=03d30ff6&scoped=true"
import script from "./person-position-grid-new.vue?vue&type=script&lang=js"
export * from "./person-position-grid-new.vue?vue&type=script&lang=js"
import style0 from "./person-position-grid-new.vue?vue&type=style&index=0&id=03d30ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../CrossD.Portal.Vue/ClientApp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d30ff6",
  null
  
)

export default component.exports